import { Modal, SubmitButton } from "@xola/ui-kit";
import React, { useState } from "react";
import { SecondaryButton } from "../../../Common/SecondaryButton";

enum ActionType {
    CONVERT = "convert",
    REMOVE = "remove",
}

interface AddonQuestionDeletionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onRemoveFromProduct: () => void;
    onConvertToOrganizerAddon: () => void;
}

export const AddonQuestionDeletionModal = ({
    isOpen,
    onClose,
    onRemoveFromProduct,
    onConvertToOrganizerAddon,
}: AddonQuestionDeletionModalProps) => {
    const [selectedAction, setSelectedAction] = useState<ActionType | null>(null);

    const handleConfirm = () => {
        if (selectedAction === ActionType.CONVERT) {
            onConvertToOrganizerAddon();
        } else if (selectedAction === ActionType.REMOVE) {
            onRemoveFromProduct();
        }
        setSelectedAction(null);
        onClose();
    };

    const handleClose = () => {
        setSelectedAction(null);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <Modal.Header>Remove Add-On</Modal.Header>

            <Modal.Body>
                <div className="space-y-4">
                    <p>
                        You are attempting to delete an add-on configured to{" "}
                        <span className="font-bold">Ask Each Attendee</span>.
                    </p>
                    <p>
                        Would you like to configure it to <span className="font-bold">Ask Organizer Only</span> or
                        remove it entirely from the product?
                    </p>

                    <div className="space-y-3">
                        <label className="flex cursor-pointer items-center space-x-3">
                            <input
                                type="radio"
                                name="action"
                                value={ActionType.CONVERT}
                                checked={selectedAction === ActionType.CONVERT}
                                className="border-gray-300 h-4 w-4"
                                onChange={(e) => setSelectedAction(e.target.value as ActionType)}
                            />
                            <span>Ask organizer only</span>
                        </label>

                        <label className="flex cursor-pointer items-center space-x-3">
                            <input
                                type="radio"
                                name="action"
                                value={ActionType.REMOVE}
                                checked={selectedAction === ActionType.REMOVE}
                                className="border-gray-300 h-4 w-4"
                                onChange={(e) => setSelectedAction(e.target.value as ActionType)}
                            />
                            <span>Remove add-on from this product</span>
                        </label>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="flex justify-end gap-3">
                    <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
                    <SubmitButton color="primary" disabled={!selectedAction} onClick={handleConfirm}>
                        Confirm
                    </SubmitButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
